import debounce from 'lodash/debounce'
riot.tag2('settings-main-preferences', '  <loader if="{loader}"></loader>\n  <div show="{!loader}">\n    <div class="row">\n      <div class="col-md-8 col-sm-12 col-xs-12">\n        <catalog-static onchange="{change}" onkeyup="{change}" cols="{cols}" rows="{items[0].parameters}" remove-toolbar="{true}" handlers="{handlers}">\n          <yield to="body">\n            <datatable-cell name="name">{row.name}</datatable-cell>\n            <datatable-cell name="value">\n              <input if="{row.valueType == &quot;S&quot;}" type="text" value="{row.value}" onclick="{stopPropagation}" onchange="{handlers.change}" onkeyup="{handlers.change}">\n              <input if="{row.valueType == &quot;B&quot;}" type="checkbox" __checked="{parseInt(row.value)}" onclick="{stopPropagation}" onchange="{handlers.change}" onmousedown="{handlers.change}">\n              <input if="{row.valueType == &quot;I&quot;}" step="1" value="{row.value}" onclick="{stopPropagation}" onchange="{handlers.change}" onkeyup="{handlers.change}" type="{\'number\'}">\n              <input if="{row.valueType == &quot;D&quot;}" step="0.01" value="{row.value}" onclick="{stopPropagation}" onchange="{handlers.change}" onkeyup="{handlers.change}" type="{\'number\'}">\n            </datatable-cell>\n          </yield>\n        </catalog-static>\n      </div>\n      <div class="col-md-4 hidden-sm hidden-sm">\n        <div class="h5"><b>Примечание по параметру</b></div>\n        <p>{note}</p>\n      </div>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;
self.items = [];
self.note = '';

self.mixin('permissions');

self.cols = [{ name: 'name', value: 'Наименование параметра' }, { name: 'value', value: 'Значение' }];

var save = debounce(function (e) {
    API.request({
        object: 'Integration',
        method: 'Save',
        data: { parameters: self.items[0].parameters },
        complete: function complete() {
            return self.update();
        }
    });
}, 600);

self.change = function (e) {
    if (self.checkPermission('settings', '0010')) save();
};

self.handlers = {
    change: function change(e) {
        if (self.checkPermission('settings', '0010')) {
            if (e.target.type === 'checkbox') this.row.value = e.target.checked;else this.row.value = e.target.value;
        } else {
            if (e.target.type === 'checkbox') e.target.checked = parseInt(this.row.value);else e.target.value = this.row.value;
        }
        this.update();
    }
};

self.reload = function () {
    self.loader = true;
    self.update();

    API.request({
        object: 'Integration',
        method: 'Fetch',
        success: function success(response) {
            self.items = response.items;
            self.loader = false;
            self.update();
        }
    });
};

self.one('updated', function () {
    self.tags['catalog-static'].tags.datatable.on('row-selected', function (count, item) {
        self.note = item.note;
        self.update();
    });
});

self.on('mount', function () {
    self.reload();
});
});


// WEBPACK FOOTER //
// ./pages/settings/settings-main-preferences.tag